<template>
  <div v-if="longitude && longitude">
    <div v-html="getMapUrl()" />
    <div class="font-size-14">{{ description }}</div>
  </div>
</template>

<script>
export default {
  name: "ChatLocation",
  props: [ "description", "latitude", "longitude"],
  methods: {
    getMapUrl() {
      let path = "<iframe\n" +
        "        width=\"400\"\n" +
        "        height=\"350\"\n" +
        "        style=\"border: 0\"\n" +
        "        loading=\"lazy\"\n" +
        "        allowFullScreen\n" +
        "        referrerPolicy=\"no-referrer-when-downgrade\"\n" +
        "        src=\"https://www.google.com/maps/embed/v1/place?key=AIzaSyDEwUImNs161Hftoim5saIqLLbcYo4V69c\n" +
        "    &q=" + Number(this.latitude).toFixed(6) + "," + Number(this.longitude).toFixed(7) + "\"\n" +
        "      >\n" +
        "      </iframe>";
      return path;
    }
  }
};
</script>

<style scoped>

</style>